import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "dialog",
  class: "edit-user rounded-lg p-6 max-w-sm w-full shadow-lg"
}
const _hoisted_2 = { class: "flex justify-end space-x-3 mt-3" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Username ", -1 /* CACHED */)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.dat_username) = $event)),
        tabindex: "160",
        class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.dat_username]
      ]),
      _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.dat_username_error), 513 /* TEXT, NEED_PATCH */), [
        [_vShow, $setup.dat_username_error]
      ])
    ]),
    _createElementVNode("div", null, [
      _cache[5] || (_cache[5] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Email ", -1 /* CACHED */)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.dat_email) = $event)),
        tabindex: "160",
        class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.dat_email]
      ]),
      _withDirectives(_createElementVNode("small", { class: "text-red-500" }, _toDisplayString($setup.dat_email_error), 513 /* TEXT, NEED_PATCH */), [
        [_vShow, $setup.dat_email]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_basic_button, {
        error: "",
        size: 'small',
        disabled: $setup.dat_loading,
        onClick: _cache[2] || (_cache[2] = $event => ($setup.cancel()))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode(" Cancel   ")
        ])),
        _: 1 /* STABLE */,
        __: [6]
      }, 8 /* PROPS */, ["disabled"]),
      _createVNode(_component_basic_button, {
        size: 'small',
        disabled: $setup.dat_loading,
        onClick: _cache[3] || (_cache[3] = $event => ($setup.save($setup.dat_username, $setup.dat_email)))
      }, {
        default: _withCtx(() => [
          ($setup.dat_loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "fa-solid fa-spinner animate-spin" }, null, -1 /* CACHED */),
                _createTextVNode(" Loading...")
              ])))
            : _createCommentVNode("v-if", true),
          (!$setup.dat_loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Save"))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ])
  ], 512 /* NEED_PATCH */))
}